import * as actions from "./actions";

const initialState = {
  initial: false,
  data: [],
  isFetchingPending: false,
  isApprovingPending: false,
  isRejectingPending: false,
  isPromotingPending: false,
  error: null,
};

const ingredientApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Pending Ingredients
    case actions.FETCH_PENDING_INGREDIENTS.REQUEST:
      return {
        ...state,
        isFetchingPending: true,
        error: null,
      };

    case actions.FETCH_PENDING_INGREDIENTS.SUCCESS:
      return {
        ...state,
        initial: true,
        isFetchingPending: false,
        data: action.payload.data,
        error: null,
      };

    case actions.FETCH_PENDING_INGREDIENTS.FAILURE:
      return {
        ...state,
        isFetchingPending: false,
        error: action.payload,
      };

    // Approve Ingredient
    case actions.APPROVE_INGREDIENT.REQUEST:
      return {
        ...state,
        isApprovingPending: true,
        error: null,
      };

    case actions.APPROVE_INGREDIENT.SUCCESS:
      return {
        ...state,
        isApprovingPending: false,
        error: null,
      };

    case actions.APPROVE_INGREDIENT.FAILURE:
      return {
        ...state,
        isApprovingPending: false,
        error: action.payload.error,
      };

    // Reject Ingredient
    case actions.REJECT_INGREDIENT.REQUEST:
      return {
        ...state,
        isRejectingPending: true,
        error: null,
      };

    case actions.REJECT_INGREDIENT.SUCCESS:
      return {
        ...state,
        isRejectingPending: false,
        error: null,
      };

    case actions.REJECT_INGREDIENT.FAILURE:
      return {
        ...state,
        isRejectingPending: false,
        error: action.payload.error,
      };

    // Promote Ingredient
    case actions.PROMOTE_INGREDIENT.REQUEST:
      return {
        ...state,
        isPromotingPending: true,
        error: null,
      };

    case actions.PROMOTE_INGREDIENT.SUCCESS:
      return {
        ...state,
        isPromotingPending: false,
        error: null,
      };

    case actions.PROMOTE_INGREDIENT.FAILURE:
      return {
        ...state,
        isPromotingPending: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default ingredientApprovalReducer;
